import { render, staticRenderFns } from "./ScheduleDetails.vue?vue&type=template&id=ed501544&scoped=true&"
import script from "./ScheduleDetails.vue?vue&type=script&lang=js&"
export * from "./ScheduleDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDetails.vue?vue&type=style&index=0&id=ed501544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed501544",
  null
  
)

export default component.exports